export const ACTIONS = {
  COPY: 'copy',
  EDIT: 'edit',
  CANCEL: 'cancel',
  RESTORE: 'restore',
  EDIT_USER: 'editUser',
  DELETE: 'delete',
  CREATE_LIST: 'createList',
  PUBLISH: 'publish',
  UNPUBLISH: 'unpublish',
  NOTIFY_SHIFT: 'notify_shift',
  NOTIFY_TIMEOFF: 'notify_timeoff',
  CREATE_ATTENDANCE: 'createAttendance',
  CREATE_PUNCHCARD: 'createPunchCard',
  UNASSIGN_EMPLOYEE: 'unassignEmployee',
  UNFINALIZE: 'unfinalize',
  FINALIZE: 'finalize',
  GO_TO_CONTACT_LIST: 'goToContactList',
  GO_TO_SCHEDULE_TEMPLATE: 'goToScheduleTemplate',
  GO_TO_USER: 'goToUser',
  GO_TO_USER_SCHEDULE: 'goToUserSchedule',
  GO_TO_ATTENDANCE: 'goToAttendance',
  GO_TO_PUNCHCARD: 'goToPunchCard',
  GO_TO_TIMEOFF: 'goToTimeOff',
  OPEN_LEAVE_COMMENTS: 'openLeaveComments',
  OPEN_VACATION_COMMENTS: 'openVacationComments'
} as const

export type ActionsTypes = ValueOf<typeof ACTIONS>
